<template>
  <div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" style="min-height: 300px;" >
    <div v-for="(item, index) in resultList" :key="index" class="item" >
      <OrderDetailBox :detailItem="item" height="2rem"  bgColor="#fff" isSearch @searchItem="searchItem(item)"></OrderDetailBox>
    </div>
    </van-list>
  </div>
</template>

<script>
import sortApi from '@/api/sort'
import { mapState } from 'vuex'
import OrderDetailBox from '@/components/order-detail-box.vue'
export default {
  components: {
    OrderDetailBox
  },
  data () {
    return {
      pageInfo: {
        page: 1,
        pageSize: 10
      },
      loading: false,
      finished: false
    }
  },
  computed: {
    ...mapState({
      keyword: state => state.search.keyword,
      resultList: state => state.search.resultList
    })
  },
  methods: {
    queryItemList () {
      this.pageInfo.page = 1
      this.finished = false
      this.loading = true
      this.onLoad()
    },
    onLoad () {
      let params = {
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        keyword: this.keyword
      }
      sortApi.queryItemList(params).then(res => {
        if (res.data.resultCode === '0') {
          const { itemList } = res.data.resultData
          if (!itemList.length) {
            this.finished = true
          }
          let resultList = this.resultList.concat(itemList || [])
          this.$store.commit('search_m_setResultListData', resultList)
          this.pageInfo.page++
          this.loading = false
        }
      })
    },
    searchItem (item) {
      this.$store.commit('search_m_setResultListData', [])
      console.log(item, 'item')
      if (item.categoryId === '212') {
        this.$router.push({
          name: 'knowledge-goods',
          query: {
            itemId: item.itemId
          }
        })
      } else {
        this.$router.push({
          name: 'goods-detail',
          query: {
            itemId: item.itemId
          }
        })
      }
    }
  }
}
</script>
<style scoped lang="less">
.item{
  margin-bottom: 0.2rem;
}
</style>
